import { supabase } from '../lib/supabase';

export async function fetchContact() {
  const { data, error } = await supabase.from('site_contact').select('*').eq('id', 1).single();
  if (error) { console.error('[contactService] fetch:', error); return null; }
  return data;
}

export async function updateContact(fields) {
  const { error } = await supabase.from('site_contact').update(fields).eq('id', 1);
  if (error) throw new Error(error.message);
}
